/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_ListInputs */

const en_layout_list = /** @type {(inputs: Layout_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

const de_layout_list = /** @type {(inputs: Layout_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste`)
};

/**
* | output |
* | --- |
* | "List" |
*
* @param {Layout_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const layout_list = /** @type {((inputs?: Layout_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_layout_list(inputs)
	return en_layout_list(inputs)
});